import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useAppServices } from "../../../../../hook/services";
import toast from "react-hot-toast";
import { useState } from "react";
import CommonModal from "../../ResetContext/components/DumpModal";
import UpgradePlanModal from "./UpgradePlanModal";
import { useUserInfo } from "../../../../../context/user";
import Downgrade from "./Downgrade";
import { useUsersContext } from "../../../../../context/usersContext";
import ContactToSupportModal from "../../../../../components/ContactToSupportModal";

const PricingPlanCard = ({ data, planType, setActiveTab, agency, setOpenCancelModal }) => {
  const AppService = useAppServices();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentMethod_id, setPaymentMethodId] = useState(null);
  const userActiveLocation = useUserInfo()[4];
  const [openDowngradeModal, setDowngradeModal] = useState(false);
  const [openContactInfoModel, setOpenContactInfoModel] = useState(false);
  const { isHighestPlan } = useUsersContext()
  const isHighest = isHighestPlan(data?._id);

  const handleUpgradeClick = async (type = "Upgrade plan") => {
    setLoading(true);
    const { response } = await AppService.subscription.getPaymentInfoByAgencyId(
      {
        agency_id: userActiveLocation?.agency_id,
        customer_id: userActiveLocation?.customer_id,
      }
    );
    if (response?.data?.id) {
      setPaymentMethodId(response.data.id);
      type === "Change plan"
        ? setDowngradeModal(true)
        : setOpenConfirmModal(true);
    } else {
      toast.error("Please add a payment method before upgrading.");
      setActiveTab("Billing");
    }
    setLoading(false);
  };
  return (
    <div
      className={`h-[500px] flex flex-col justify-between group gap-4 p-4 w-full rounded-md  border !border-[#D9D9D9] ${data?.activePlan ? "bg-[#f5f5f5]" : "bg-white"
        } ${!data?.activePlan && "hover:bg-[#F6F0FF] hover:!border-[#5700C7]"}`}
    >
      <div className="flex flex-col gap-4">
        <p className="font-bold">{data?.plan?.planName}</p>

        <div className="flex gap-2 items-center">
          {data?.is_free_saas ? (
            <span>Free</span>
          ) : (
            <>
              <h3 className="text-3xl font-bold">
                £
                {planType === "monthly"
                  ? parseInt(data?.monthly_amount) / 100
                  : parseInt(data?.yearly_amount) / 100}
              </h3>
              <p className="text-gray-400">
                /{planType === "monthly" ? "month" : "year"}
              </p>
            </>
          )}
        </div>

        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-3">
            <CheckCircleIcon className="text-green-500" />
            <p className="text-sm">AI Agents</p>
          </div>
          <div className="flex items-center gap-3">
            {parseInt(data?.user_limit) > 0 ? (
              <CheckCircleIcon className="text-green-500" />
            ) : (
              <CancelIcon className="text-red-500" />
            )}
            <p className="text-sm">
              {parseInt(data?.user_limit) > 0 && parseInt(data?.user_limit)}{" "}
              Users
            </p>
          </div>
          <div className="flex items-center gap-3">
            {data?.create_agents ? (
              <CheckCircleIcon className="text-green-500" />
            ) : (
              <CancelIcon className="text-red-500" />
            )}
            <p className="text-sm">AI Agent Builder</p>
          </div>
          {data?.promptlabel_ids?.length > 0 && (
            <div className="flex items-center gap-3">
              {data?.promptlabel_ids?.length > 0 ? (
                <CheckCircleIcon className="text-green-500" />
              ) : (
                <CancelIcon className="text-red-500" />
              )}
              <p className="text-sm">{data?.promptlabel_ids?.length} AI Agent Templates</p>
            </div>
          )}
          <div className="flex items-center gap-3">
            <CheckCircleIcon className="text-green-500" />
            <p className="text-sm">
              Workspaces:{"  "}
              {parseInt(data?.additional_accounts) > 0
                ? parseInt(data?.additional_accounts)
                : 1}
            </p>
          </div>
          <div className="flex items-center gap-3">
            {parseInt(data?.daily_token_usage) ? (
              <CheckCircleIcon className="text-green-500" />
            ) : (
              <CancelIcon className="text-red-500" />
            )}
            <p className="text-sm">
              Monthly AI Tasks:{"  "}
              {parseInt(data?.daily_token_usage) > 0
                ? data?.daily_token_usage
                : "Unlimited"}
            </p>
          </div>
        </div>
      </div>

      <div>
        <div
          className={`w-full p-2 ${!data?.activePlan && "group-hover:bg-black group-hover:text-white"
            } cursor-pointer rounded-[4px] text-center ${data?.activePlan
              ? "bg-[#d9d9d9] border !border-[#d9d9d9] text-[#757575]"
              : "bg-white text-black border"
            } `}
          onClick={() => {
            if (!data?.activePlan || !loading) {
              if (data?.is_free_saas) {
                setOpenCancelModal(true);
              } else if (isHighest)
                setOpenContactInfoModel(true)
              else {
                handleUpgradeClick(data?.buttonLabel);
              }
            }
          }}
        >
          {loading ? "wait... " : data?.buttonLabel}
        </div>
      </div>
      {openConfirmModal && (
        <CommonModal
          isOpen={openConfirmModal}
          onClose={() => setOpenConfirmModal(false)}
          showAlert={false}
          title=""
        >
          <UpgradePlanModal
            price_id={
              planType === "monthly" ? data?.monthly_id : data?.yearly_id
            }
            plan={data}
            onClose={() => setOpenConfirmModal(false)}
            paymentMethod_id={paymentMethod_id}
            agency={agency}
          />
        </CommonModal>
      )}
      <Downgrade
        isOpen={openDowngradeModal}
        onClose={() => setDowngradeModal(false)}
        agency={agency}
        price_id={planType === "monthly" ? data?.monthly_id : data?.yearly_id}
        plan={data}
        paymentMethod_id={paymentMethod_id}
      />
      {openContactInfoModel && <ContactToSupportModal isOpen={openContactInfoModel} onClose={() => setOpenContactInfoModel(false)} />}
    </div>
  );
};

export default PricingPlanCard;
